import { ChaosTableStudentStatus } from '../../admin/admin.status';
import { ChaosTableStatus, PaymentMethod, Source } from './chaos-table.enum';

export interface ChaosTableRow {
   id: number;
   source: Source;

   area: string;
   name: string;
   phone: string;
   email: string;
   project: string;
   birthDate?: Date;

   taxNumber?: string;
   uuid?: string;
   createdBy?: string;
   createdAt?: Date;
   startDate?: Date;
   loginLinkDate?: Date;
   rowStatus?: ChaosTableStatus;
   studentStatus?: ChaosTableStudentStatus;
   paymentMethod?: PaymentMethod;
   syncDate?: Date;
   check?: string;
   comment?: string;
   reminderDate?: Date;
   approvedBy?: string;
   approvedAt?: Date;
   dataSupplementEmailDate?: Date;
   hasPossibleMatch?: boolean;
   language?: LanguageEnum;
   deleted?: boolean;
}

export enum LanguageEnum {
   HU = 'HU',
   EN = 'EN'
}
